import { useCallback, useRef } from 'react';
import { useMsal } from '@azure/msal-react';
import { useTrackingApiService } from 'api/providers/AppServiceProvider';
import { DeviceIdHelper } from 'common/helpers/device-id-helper';

export const useTrackClick = () => {
	const trackingService = useTrackingApiService();
	const { accounts } = useMsal();
	const deviceId = useRef(DeviceIdHelper.getOrCreateDeviceId());

	const trackClick = useCallback(
		(elementName: string, elementId: string) => {
			if (accounts.length === 0 || !trackingService) {
				return;
			}

			trackingService
				.TrackClick(elementName, elementId, window.location.href, deviceId.current)
				.catch((error) => {
					console.error(`Failed to track ${elementName}:`, error);
				});
		},
		[accounts.length, trackingService]
	);

	return trackClick;
};
